// apps/admin/src/features/services/components/ServiceDetailsPage.tsx
import { ServicesDataProvider } from '../context/ServicesContext';
import ServiceDetail from './ServiceDetail';

/**
 * ServiceDetailsPage
 *
 * This component serves as the detail page for a single service, typically rendered at the route `/services/:id`.
 * It wraps the `ServiceDetail` component with the `ServicesDataProvider` context, ensuring that all service-related
 * data and actions are available to `ServiceDetail` and its children. This pattern allows for context-driven
 * state management and data fetching, and ensures the detail view is always in sync with the latest service data.
 *
 * Usage:
 *   <Route path="/services/:id" element={<ServiceDetailsPage />} />
 *
 * Context:
 *   - Provides service data and actions via ServicesDataProvider
 *   - Used by ServiceDetail to display and manage a single service
 */
export default function ServiceDetailsPage() {
  return (
    <ServicesDataProvider>
      <ServiceDetail />
    </ServicesDataProvider>
  );
}